import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaImages, FaBook, FaCogs, FaSignOutAlt, FaUserShield } from 'react-icons/fa';
const Sidebar = ({ pageCount, isOpen, closeMenu, onLogout, user }) => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <button className="close-btn" onClick={closeMenu}>&times;</button>
      <div className="logo">🧩 Puzzlify</div>
      <nav className="nav-links">
        <Link to="/dashboard" className={isActive('/dashboard')} onClick={closeMenu}><FaHome /> Dashboard</Link>
        <Link to="/my-book" className={isActive('/my-book')} onClick={closeMenu}><FaBook /> My Book <span className="badge">{pageCount}</span></Link>
        <Link to="/cover-maker" className={isActive('/cover-maker')} onClick={closeMenu}><FaImages /> Cover</Link>
        <Link to="/autoGenerator" className={isActive('/autoGenerator')} onClick={closeMenu}><FaCogs /> Auto Generator</Link>
        {/* Admin Link */}
        {user && (user.role === 'admin' || user.role === 'super_user') && (
           <Link to="/admin" className={isActive('/admin')} onClick={closeMenu} style={{ color: '#e74c3c' }}>
             <FaUserShield /> Admin
           </Link>
        )}
      </nav>
      <div className="user-section">
        {user ? (
          <div><div className="user-info">{user.name}</div><button onClick={onLogout} className="logout-btn"><FaSignOutAlt /> Logout</button></div>
        ) : (<Link to="/login" className="login-btn" onClick={closeMenu}>Login</Link>)}
      </div>
    </div>
  );
};
export default Sidebar;
